module.exports = __webpack_public_path__ + "img/lythbenner.77e8ccfc.png";